export default "__VITE_ASSET__a17991b8__"